<template>
  <div class="profile-block">
    <p class="profile-block__title title" @click="emit('toggleFilter')">
      Анкеты
      <span v-if="searchStore.filtersProfiles" class="title_green">
        Указаны {{ searchStore.filtersProfiles }} параметр
      </span>
      <span v-else class="title_green">Не указаны</span>
      <ArrowIcon
        class="title__arrow"
        :class="{ 'title__arrow_active': visibleFiltersProfiles }"
      />
    </p>

    <transition name="fade-slide">
    <div v-if="visibleFiltersProfiles" class="profile-block-wrapper">
      <div class="profile-block__element">
        <p class="profile-block__title">
          Имя или телефон
        </p>
        <pInput
          class="profile-block__input"
          :iconName="'search'"
          :outLabel="true"
          :value="searchStore.searchOptions.profileInfo.searchText"
          :placeholder="'Введите имя или номер телефона'"
          @input="searchStore.searchOptions.profileInfo.searchText = $event.target.value"
        />
      </div>
      
      <div class="profile-block__element">
        <p class="profile-block__title">
          Созданные
        </p>
        <pSelect
          class="profile-block__input"
          :selectionItems="profileTimesDescription"
          v-model="searchStore.searchOptions.profileInfo.time"
        />
      </div>

      <div class="profile-block__element">
        <p class="profile-block__title">
          Наличие соц. сетей
        </p>
        <pSelect
          class="profile-block__input"
          :selectionItems="withSocial"
          v-model="searchStore.searchOptions.profileInfo.withSocial"
        />
      </div>

      <div class="options">
        <pCheckbox
            :modelValue="searchStore.searchOptions.profileInfo.verified"
            :label="'Проверенные'"
            @update:modelValue="searchStore.searchOptions.profileInfo.verified = !searchStore.searchOptions.profileInfo.verified"
        />
        <pCheckbox
            :modelValue="searchStore.searchOptions.profileInfo.withVideo"
            :label="'С видео'"
            @update:modelValue="searchStore.searchOptions.profileInfo.withVideo = !searchStore.searchOptions.profileInfo.withVideo"
        />
        <pCheckbox
            :modelValue="searchStore.searchOptions.profileInfo.withReviews"
            :label="'С отзывами'"
            @update:modelValue="searchStore.searchOptions.profileInfo.withReviews = !searchStore.searchOptions.profileInfo.withReviews"
        />
      </div>
    </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import pSelect from '@/common/pSelect/pSelect.vue'
import pCheckbox from '@/common/pCheckbox/pCheckbox.vue'
import pInput from '@/common/pInput/pInput.vue'
import ArrowIcon from '@/common/icons/ArrowIcon.vue'
import ProfileTimes from "@/searchSection/types/ProfileTimes";
import { ref, Ref, computed, ComputedRef } from "vue";
import { useSearchStore } from "@/searchSection/store/searchStore";

defineProps<{ visibleFiltersProfiles: boolean }>();
const emit = defineEmits(['toggleFilter']);

const searchStore = useSearchStore()
const profileTimes: Ref<ProfileTimes> = ref({
  allTime: 'За все время',
  year: 'За последний год',
  month: 'За последний месяц',
  week: 'За последнюю неделю',
  days: 'За последние 2 дня',
})

const profileTimesDescription: ComputedRef<{ id: string | number; name: string }[]> = computed(() => {
  return Object.entries(profileTimes.value).map(([key, value]) => ({
    id: key,
    name: value
  }))
})

const withSocial: Ref = ref([
  {
    id: 'pass',
    name: 'Не важно',
  },
  {
    id: 'yes',
    name: 'Да',
  },
])
</script>

<style scoped lang="scss">
.profile-block {
  &-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 12px;
    row-gap: 20px;
    margin-top: 16px;

    @media screen and (max-width: 580px) {
      grid-template-columns: 1fr;
      gap: 15px;
    }
  }

  &__element {
    display: flex;
    flex-direction: column;
    gap: 6px;

    &:first-child {
      grid-column: 1/3;
    }
  }

  &__input {
    :deep(input) {
      padding: 0 12px;
    }

    :deep(.p-icon-search) {
      right: 12px;
      left: auto;
    }
  }

  .options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    grid-column: 1/3;
    padding-right: 50px;
    column-gap: 20px;

    @media screen and (max-width: 580px) {
      grid-column: initial;
      flex-wrap: wrap;
      gap: 15px;
    }
  }
}
</style>